// Is Workspaces switched on for this client? (config seam: WORKSPACES_ENABLED,
// mirroring the server's workspacesEnabled.)
//
// Read through a NAMESPACE import on purpose: a client fork's own
// client-custom/frontend/client.config.js predates this key, and a named
// import of a missing export fails the build. Here a missing key is just
// undefined — off — so a fork merging this product change keeps building
// and sees nothing new until it adds `export const WORKSPACES_ENABLED = true`.
import * as clientConfig from '@client/config/client.config';

export const WORKSPACES_ENABLED = clientConfig.WORKSPACES_ENABLED === true;
